import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import React from 'react';
import moment from "moment";

const Graph = ({ data }) => {
    data = data.map((row) => (row.datetime = moment.unix(row.timestamp).utc().format('YYYY-MM-DD HH:00'), row));

    return (
        <ResponsiveContainer width={'100%'} height={300}>
            <LineChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5, right: 30, left: 20, bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="datetime" />
                <YAxis yAxisId="left" />
                <YAxis yAxisId="right" orientation="right"/>
                <Tooltip/>
                <Legend/>

                <Line yAxisId="left" type="linear" dataKey="clicks" stroke="#E34A6F" dot={{ stroke: '#E34A6F', strokeWidth: 3 }} activeDot={{ stroke: '#E34A6F', strokeWidth: 3 }} strokeWidth={3} />
                <Line yAxisId="left" type="linear" dataKey="revenue" stroke="#EFCA08" dot={{ stroke: '#EFCA08', strokeWidth: 3 }} activeDot={{ stroke: '#EFCA08', strokeWidth: 3 }} strokeWidth={3} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default Graph;



// WEBPACK FOOTER //
// ./src/scenes/BidderPluginReport/components/Graph/index.js